import Skeleton from 'react-loading-skeleton';

import { Card } from '../Card/Card';

export const LoadingCard = () => {
  return (
    <Card title={<Skeleton height="20px" containerClassName="w-[40%]" />}>
      <div data-testid="card-loading-skeleton">
        <Skeleton width="90%" />
        <Skeleton width="70%" />
        <Skeleton width="80%" />
      </div>
    </Card>
  );
};
